import { useIntl } from 'react-intl';

import { SharePatientReq } from '@/shared/api/protocol-ts/api/core/svc_access_pb';
import { useAppDispatch } from '@/shared/hooks';
import { normalizeEmail } from '@/shared/lib';

import { accessModel } from '@/entities/access';
import { ModalID, modalModel } from '@/entities/modal';

export const useInviteForSharingPatient = () => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();

  const openProtectedSharingModal = ({
    accessCode,
    invitationCreateDate,
  }: {
    accessCode: string;
    invitationCreateDate: Date | number;
  }) => {
    dispatch(
      modalModel.actions.openModal({
        modalID: ModalID.ProtectedSharing,
        data: { accessCode, invitationCreateDate },
      }),
    );
  };

  return async ({
    comment,
    sharedPatientDoctorEmail,
    patientID,
    isProtectedSharing,
  }: {
    patientID: string;
    sharedPatientDoctorEmail: string;
    comment: string;
    isProtectedSharing: boolean;
  }) => {
    const { Sharing: createdInvitation } = await dispatch(
      accessModel.thunks.inviteForSharingPatient(
        new SharePatientReq({
          RecipientEmail: normalizeEmail(sharedPatientDoctorEmail),
          PatientID: patientID,
          AutoAccept: !isProtectedSharing,
          Comment: comment,
        }),
      ),
    ).unwrap();

    if (createdInvitation) {
      dispatch(accessModel.sharingActions.setOne(createdInvitation));
    }

    if (isProtectedSharing) {
      openProtectedSharingModal({
        invitationCreateDate: createdInvitation?.Created?.At?.toDate() ?? 0,
        accessCode: createdInvitation?.Secret ?? '',
      });
    } else {
      dispatch(
        modalModel.actions.openModal({
          modalID: ModalID.CongratsModal,
          data: {
            title: formatMessage({
              id: 'sharePatient.successfullyShared',
              defaultMessage: 'The patient’s case has been successfully shared',
            }),
          },
        }),
      );
    }
  };
};
